import React from 'react';

// Skeleton-first loading: the page shell renders immediately and these
// shimmer in place of the CTA stack / pass card until the keyword resolves,
// so loading → loaded is a reveal, not a screen swap.

export const CtaSkeleton: React.FC = () => (
  <div className="space-y-3 animate-pulse" aria-hidden>
    <div className="h-[52px] rounded-xl bg-gray-300/70" />
    <div className="h-[52px] rounded-xl bg-gray-300/70" />
    <div className="h-11 rounded-xl bg-gray-200" />
    <div className="h-4 w-40 mx-auto rounded bg-gray-200" />
  </div>
);

export const PassCardSkeleton: React.FC<{ slow?: boolean }> = ({ slow }) => (
  <div className="w-full">
    <div className="rounded-3xl bg-gray-800 shadow-xl overflow-hidden animate-pulse" aria-hidden>
      <div className="px-5 pt-4 pb-2 flex items-start justify-between">
        <div className="h-9 w-20 rounded bg-white/20" />
        <div className="space-y-1.5 flex flex-col items-end">
          <div className="h-2.5 w-12 rounded bg-white/15" />
          <div className="h-6 w-16 rounded bg-white/25" />
        </div>
      </div>
      <div className="px-5 pb-3">
        <div className="h-5 w-24 rounded-md bg-white/15" />
      </div>
      <div className="h-24 bg-white/10" />
      <div className="px-5 py-4 flex gap-6">
        <div className="space-y-1.5">
          <div className="h-2.5 w-14 rounded bg-white/15" />
          <div className="h-3.5 w-20 rounded bg-white/25" />
        </div>
        <div className="space-y-1.5">
          <div className="h-2.5 w-16 rounded bg-white/15" />
          <div className="h-3.5 w-24 rounded bg-white/25" />
        </div>
      </div>
      <div className="px-5 pb-5">
        <div className="h-24 rounded-2xl bg-white/90" />
      </div>
    </div>
    <div
      className={`mt-4 text-center text-sm text-gray-500 transition-opacity duration-500 ${slow ? 'opacity-100' : 'opacity-0'}`}
      role="status"
    >
      Still fetching your pass — hang tight…
    </div>
  </div>
);

export const TilesSkeleton: React.FC = () => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 animate-pulse" aria-hidden>
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="bg-white rounded-2xl border border-[#E4EAE2] px-4 py-4 space-y-2.5">
        <div className="w-10 h-10 rounded-xl bg-gray-200" />
        <div className="h-2.5 w-16 rounded bg-gray-200" />
        <div className="h-3.5 w-20 rounded bg-gray-300" />
      </div>
    ))}
  </div>
);
